var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0D3743;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,69.5H4.8c-2.4,0-4.3-1.9-4.3-4.3V4.8c0-2.4,1.9-4.3,4.3-4.3h60.4c2.4,0,4.3,1.9,4.3,4.3v60.4 C69.5,67.6,67.6,69.5,65.2,69.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,39.7l-16-8c-0.7-0.3-1.5-0.3-2.2,0l-16,8V23.9h-5.1H6.1C6,23.9,6,24,6,24l7.4,4.3v15.8 c0,1.5,1.8,2.4,3.3,1.7l18.9-9.5l18.9,9.5c1.5,0.7,3.3-0.2,3.3-1.7V23.9h-5.1L52.8,39.7L52.8,39.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalley);
export default __webpack_public_path__ + "static/media/walley.84e9020a163b29081f4d0b15a7ddeebb.svg";
export { ForwardRef as ReactComponent };